import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, Router, UrlTree} from '@angular/router';
import {UserRole} from '@emma-labs/shared/typescript';
import {Observable} from 'rxjs';
import {first, map} from 'rxjs/operators';
import {AgentSession} from './entities/agent-session';
import {AuthService} from './services/auth.service';

export const UserRoleGuard = (route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> => {
  const router = inject(Router);
  const authService = inject(AuthService);

  return authService.currentAgentSessionOrAuthError.pipe(
    first(),
    map((session: AgentSession) => {
      const permittedUserRoles = route.data['permittedUserRoles'] as UserRole[];
      const isUserPermitted = permittedUserRoles.some(
        (permittedRole) => permittedRole === session.agent.role,
      );

      if (!isUserPermitted) {
        return router.parseUrl('/dashboard');
      }

      return true;
    }),
  );
};
